import { useRef, useEffect } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';

import './App.css';

import Navigations from './navigations';
import { os, isBrowser, isTelegram, isRoninBrowser, isMetaMaskBrowser } from './utils/browser';
import InstallGuide from './components/InstallGuide';
import { createFingerprint } from './utils';

const hasWrapperBrowser = isTelegram || isRoninBrowser || isMetaMaskBrowser;
const showInstallButton = isBrowser && !hasWrapperBrowser && ['iOS', 'Android'].includes(os);

const handleGetTeleRefCode = () => {
  if (!window.Telegram) return {};
  try {
    const webAppInitData = window.Telegram.WebView.initParams.tgWebAppData;
    const webAppInitDataUnsafe = window.Telegram.Utils.urlParseQueryString(webAppInitData);

    for (const key in webAppInitDataUnsafe) {
      const val = webAppInitDataUnsafe[key];
      try {
        if (
          (val.substr(0, 1) === '{' && val.substr(-1) === '}') ||
          (val.substr(0, 1) === '[' && val.substr(-1) === ']')
        ) {
          webAppInitDataUnsafe[key] = JSON.parse(val);
          const refCode = window.Telegram.WebApp.initDataUnsafe.start_param;
          return { refCode };
        }
      } catch (e) {
        console.log(e);
      }
    }
  } catch (err) {
    console.error(err);
    console.error(`----- err handleGetTeleRefCode, ${err.message} -----`);
    return {};
  }
};

const App = () => {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  const loaded = useRef();

  useEffect(() => {
    const xDeviceFingerprint = 'xDeviceFingerprint';
    let fingerprint = localStorage.getItem(xDeviceFingerprint);
    if (!fingerprint) {
      createFingerprint().then((fp) => {
        localStorage.setItem(xDeviceFingerprint, fp);
      });
    }
  }, []);

  useEffect(() => {
    if (isTelegram) {
      const { refCode } = handleGetTeleRefCode();
      if (refCode) {
        localStorage.setItem('ff-ref-code', refCode);
      } else {
        localStorage.removeItem('ff-ref-code');
      }
    } else if (!loaded.current && pathname === '/') {
      loaded.current = true;
      const code = searchParams.get('code');
      if (code) {
        localStorage.setItem('ff-ref-code', code);
      }
    }
  }, [pathname, isTelegram]);

  return (
    <>
      <Navigations />
      {showInstallButton && <InstallGuide />}
    </>
  );
};

export default App;
